<template>
  <div>
    <div class="search_block">
      <Search
        :filed="searchField"
        :searchAction="searchAction"
        :searchStatus="searchStatus"
      ></Search>
    </div>
    <div
      class="costruction table_outter_block"
      style="height: calc(100vh - 0px)"
    >
      <div class="update_btn flex flex_end">
        <button class="btn_warning" @click="updateUOF">
          <i class="el-icon-refresh-left"></i>更新UOF狀態
        </button>
      </div>
      <Loading part></Loading>
      <div v-if="tableData.length !== 0">
        <PersonalTable>
          <TableThead
            :thead="thead"
            :thead_scroll="thead_scroll"
            slot="thead"
            @tableSort="tableSort"
            @eventGetHeight="eventGetHeight"
          ></TableThead>
          <div
            class="personal_data_table"
            slot="tbody"
            :style="`top:${table_head_heigh}px;  height:calc(100vh - ${
              230 - table_head_heigh
            }px);`"
            @scroll="scrollEvent"
          >
            <table>
              <colgroup>
                <col
                  v-for="(th, index) in thead"
                  :key="index"
                  :width="th.width"
                />
              </colgroup>
              <tbody>
                <template v-for="(data, index) in pageData">
                  <tr :class="finishCase(data)" :key="`application_${index}`">
                    <template v-for="(th, th_index) in thead">
                      <!--展開每日施工單-->
                      <td
                        :class="th.align == 'center' ? 'text_center' : false"
                        :key="`info_${th_index}`"
                        v-if="th.value == 'info'"
                      >
                        <div class="info_icon" @click="openWork(data, index)">
                          <i class="el-icon-more"></i>
                        </div>
                      </td>
                      <!-- 連結 -->
                      <td
                        :class="th.align == 'center' ? 'text_center' : false"
                        class="uof_link"
                        @click="openOrder(data)"
                        :key="`uof_${th_index}`"
                        v-else-if="th.value == 'link'"
                      >
                        <button class="icon_btn btn_primary">
                          <i class="el-icon-link"></i>
                        </button>
                      </td>
                      <!--是否結案-->
                      <td
                        :class="th.align == 'center' ? 'text_center' : false"
                        :key="`state_${th_index}`"
                        v-else-if="th.value == 'finish'"
                      >
                        <template v-if="data.status !== '簽核中'">
                          <p class="blue"><i class="el-icon-success"></i></p>
                        </template>
                        <template v-else
                          ><i class="el-icon-error"></i
                        ></template>
                      </td>
                      <!--承辦人員-->
                      <td
                        class="th.align == 'center' ? 'text_center' : false"
                        :key="`employee_${th_index}`"
                        v-else-if="th.value == 'employee_id'"
                      >
                        <template v-if="data.employee">
                          {{
                            labelTransform({
                              key: "department",
                              data: data.employee.department_id,
                              inner_key: ["department_id"],
                            })
                          }}
                          /
                          {{ data.employee.name }}
                        </template>
                      </td>
                      <!--陣列-->
                      <td
                        class="table_array"
                        :class="th.align == 'center' ? 'text_center' : false"
                        :key="`array_${th_index}`"
                        v-else-if="
                          data[th.value] && Array.isArray(data[th.value])
                        "
                      >
                        <p v-for="item in data[th.value]" :key="item">
                          {{
                            labelTransform({
                              key: th.value.split("_")[0],
                              data: item,
                              inner_key: ["id", "vendor_id"],
                            })
                          }}
                        </p>
                      </td>
                      <!--default-->
                      <td
                        :class="th.align == 'center' ? 'text_center' : false"
                        :key="`data_${th_index}`"
                        v-else
                      >
                        {{ data[th.value] }}
                      </td>
                    </template>
                  </tr>
                  <!---展開第二層-->
                  <tr
                    class="table_second"
                    :key="`daliy_${index}`"
                    v-if="inner_status && inner_status_index == index"
                  >
                    <td :colspan="thead.length">
                      <div class="table_second__innerbox">
                        <div
                          class="item"
                          :class="inner_thead.dependent ? false : 'independent'"
                          v-for="(inner_thead, inner_thead_index) in innerThead"
                          :key="inner_thead_index"
                        >
                          <div class="name">{{ inner_thead.name }}</div>
                          <!-- 連結 -->
                          <template
                            class="uof_link"
                            v-if="inner_thead.value == 'link'"
                          >
                            <button class="btn_border" @click="openOrder(data)">
                              <i class="el-icon-link"></i>
                            </button>
                          </template>
                          <!--陣列-->
                          <template
                            v-else-if="
                              data[inner_thead.value] &&
                              Array.isArray(data[inner_thead.value])
                            "
                          >
                            <p
                              v-for="item in data[inner_thead.value]"
                              :key="item"
                            >
                              <i class="el-icon-caret-right"></i>
                              {{
                                labelTransform({
                                  key: inner_thead.value.split("_")[0],
                                  data: item,
                                  inner_key: ["id"],
                                })
                              }}
                            </p>
                          </template>
                          <template v-else>
                            {{ data[inner_thead.value] }}
                          </template>
                        </div>
                        <div class="item">
                          <div class="name">施工單編號</div>
                          <template v-if="data.works.length !== 0">
                            <div
                              class="table_second__innerbox__construction"
                              v-for="(
                                inner_data, inner_data_index
                              ) in data.works"
                              :key="`construction_${inner_data_index}`"
                            >
                              {{ inner_data.date }} ▶
                              {{ inner_data.form_id }}({{ inner_data.status }})
                            </div>
                          </template>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </PersonalTable>
        <el-pagination
          :page-size="page.size + 1"
          :pager-count="11"
          layout="prev, pager, next"
          :total="page.allPage"
          @current-change="pageChange"
        ></el-pagination>
      </div>
      <div class="no_data" v-else-if="this.$store.state.loading == false">
        <i class="el-icon-warning-outline"></i>
        <p>NO Data</p>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.costruction {
  .info_icon {
    cursor: pointer;
  }
  .table_array {
    p {
      padding: 5px 10px;
      margin: 5px 0;
      border-radius: 5px;
      background: lighten(#682dff, 35%);
    }
  }
}
.text_center {
  text-align: center;
}
.search_block {
  margin-top: 10px;
}
.search {
  cursor: pointer;
  > div {
    align-items: center;
  }
}
.update_btn {
  > button {
    width: 150px;
  }
}
.upload_box {
  input {
    display: none;
  }
  .upload_UI {
    margin-top: 10px;
    font-size: 13px;
    border-radius: 5px;
    cursor: pointer;
    border: 1px dashed #ccc;
    display: block;
    text-align: center;
    padding: 10px 50px;
    color: #ccc;

    &:hover {
      border: 1px solid #fff;
      color: #fff;
      i {
        color: #fff;
      }
    }
  }
}
</style>
<script>
import TableThead from "@/components/global/table/components/TableFixHead";
import PersonalTable from "@/components/global/table/PersonalTable.global";
import mixins from "@/components/mixins.js";
import Options from "@/utils/options";
import Search from "@/components/global/Search";
import Action from "@/components/global/Action";
export default {
  name: "new-construction",
  mixins: [mixins],
  components: {
    PersonalTable,
    TableThead,
    Search,
    Action,
  },
  data() {
    return {
      thead: [
        {
          name: "細節",
          width: "50px",
          value: "info",
          align: "center",
        },
        {
          name: "簽核結案",
          width: "90px",
          value: "finish",
          align: "center",
        },

        {
          name: "工程名稱",
          width: "200px",
          value: "name",
          align: "left",
        },
        {
          name: "施工開始時間",
          width: "120px",
          value: "start_date",
          align: "left",
        },
        {
          name: "施工結束時間",
          width: "120px",
          value: "end_date",
          align: "left",
        },
        {
          name: "承辦人員",
          width: "150px",
          value: "employee_id",
          align: "left",
        },
        {
          name: "承攬商名稱",
          width: "200px",
          value: "vendor_id",
          align: "left",
        },
      ],
      inner_status: false,
      inner_status_index: null,
      innerThead: [
        {
          name: "申請日期",
          dependent: false,
          value: "apply_date",
          align: "center",
        },
        {
          name: "工程編號",
          dependent: false,
          value: "form_id",
          align: "left",
        },
        {
          name: "工程內容說明",
          dependent: true,
          value: "content",
          align: "left",
        },
        {
          name: "UOF表單",
          dependent: false,
          value: "link",
          align: "center",
        },
        {
          name: "簽核狀況",
          dependent: false,
          value: "status",
          align: "left",
        },
        {
          name: "現在站點",
          dependent: false,
          value: "current_site",
          align: "center",
        },
        {
          name: "作業區域",
          dependent: false,
          value: "area_id",
          align: "left",
        },
      ],
      innerTheadConstructionList: [
        {
          name: "施工單編號",
          width: "140px",
          value: "form_id",
          align: "center",
        },
      ],
      table_head_heigh: 50,
      thead_scroll: 0,
      tableData: [],
      innerTableData: [],
      page: {
        size: 7,
        page: 1,
        allPage: null,
      },
      options: {
        contractor: [],
        special: [],
        employee: [],
        employee_key: "name",
        area: [],
        area_key: "location",
        type: [],
        type_key: "name",
        vendor: [],
        vendor_employees: [],
        vendor_employees_key: "name",
        vendor_key: "vendor_chinese",
        op: [],
        op_key: "op_name",
        department: [],
        department_key: "department",
      },
      searchStatus: false,
      uploadFile: [
        {
          name: "工具箱會議及危害告知",
          value: "toolbox",
        },
        {
          name: "承攬商入場切結書",
          value: "affidavit",
        },
      ],
      formData: new FormData(),
      file_list: {},
    };
  },
  computed: {
    searchField() {
      return [
        {
          label: "承攬商",
          value: "vendor_id",
          type: "select",
          options: this.options.vendor,
          options_value: "vendor_id",
          options_label: "vendor_chinese",
        },
        {
          label: "施工開始時間",
          value: "start_date",
          type: "date",
          options: null,
        },
        {
          label: "施工結束時間",
          value: "end_date",
          type: "date",
          options: null,
        },
        {
          label: "表單狀況",
          value: "status",
          type: "select",
          options: [
            {
              label: "同意",
              value: "同意",
            },
            {
              label: "否決",
              value: "否決",
            },
            {
              label: "作廢",
              value: "作廢",
            },
            {
              label: "簽核中",
              value: "簽核中",
            },
          ],
          options_value: "value",
          options_label: "label",
        },
      ];
    },
    pageData() {
      const list = [];
      for (
        let i = this.page.size * (this.page.page - 1);
        i < this.page.page * this.page.size;
        i++
      ) {
        if (this.tableData[i]) {
          list.push(this.tableData[i]);
        }
      }
      return list;
    },
    finishCase() {
      return function (data) {
        if (
          this.$moment().isAfter(data.date) &&
          !this.$moment().isSame(data.date, "date")
        ) {
          return "finish_case";
        }
      };
    },
  },
  methods: {
    scrollEvent(el) {
      this.thead_scroll = el.target.scrollLeft;
    },
    eventGetHeight(height) {
      this.table_head_heigh = height;
    },
    tableSort(sort_attr) {
      //關閉展開細向
      this.inner_status = false;
      this.inner_status_index = null;
      if (sort_attr.includes("_sort")) {
        //順排
        const attr = sort_attr.split("_sort")[0];
        this.tableData = this.isSort({
          data: this.tableData,
          attr: attr,
          type: "sort",
        });
      } else {
        //逆排
        this.tableData = this.isSort({
          data: this.tableData,
          attr: sort_attr,
          type: "reverse",
        });
      }
    },
    pageChange(value) {
      this.page.page = value;
      //改變頁數先關閉展開係向
      this.inner_status = false;
      this.inner_status_index = null;
    },
    getData(search) {
      this.$store.commit("loadingAction", true);
      //工程單
      if (this.is_role == "department") {
        search["department_id"] = this.$store.state.user.id;
      }

      this.$http.api.admin.getApplication(search).then((res) => {
        this.searchStatus = false;
        this.page.allPage = res.data.length;
        this.tableData = res.data;
        this.$store.commit("loadingAction", false);
      });
      //施工單
      // this.$http.api.vendor.getDailyConstruction().then((res) => {
      //   this.innerTableData = res.data;
      // });
    },
    labelTransform({ key, inner_key, data, raw_data }) {
      const item = this.options[key].find((el) => {
        for (let el_key in el) {
          if (inner_key.includes(el_key)) {
            return data == el[el_key];
          }
        }
      });
      if (item) {
        return item[this.options[`${key}_key`]];
      }
    },
    openWork(data, index) {
      if (
        this.inner_status_index !== null &&
        this.inner_status_index == index
      ) {
        //代表已經開啟且同一個，要關閉
        this.inner_status = false;
        this.inner_status_index = null;
      } else {
        this.inner_status = true;
        this.inner_status_index = index;
      }
    },
    setTableKey(key) {
      if (key.includes("_")) {
        return key.split("_")[0];
      } else {
        return key;
      }
    },
    openOrder(item) {
      window.open(item.link, "_blank");
    },
    searchAction(search) {
      this.searchStatus = true;
      this.getData(search);
    },
    print(data) {
      let obj = {
        id: data.id,
        type: "daily",
      };
      this.blankLink("print", obj);
    },
    async updateUOF() {
      await this.$http.api.admin.updateApplication();
      await this.$http.api.admin.updateWork();
      this.getData({});
    },
    upload(e, file_type) {
      this.$set(this.file_list, file_type, e.target.files[0].name);
      this.formData.append(file_type, e.target.files[0]); //放進上傳的檔案
    },
    cancelUpload(fileValue) {
      this.file_list[fileValue] = null;
      this.formData.delete(fileValue);
    },
  },
  async created() {
    this.$store.commit("loadingAction", null);
    this.options.vendor = await Options.getVendor();
    this.options.employee = await Options.getDepartmentEmployee();
    this.options.area = await Options.getArea();
    this.options.vendor_employees = await Options.getVenderEmployee();
    this.options.type = await Options.constructionType();
    this.options.op = await Options.getSpecialOperation();
    this.options.department = await Options.getDepartment();
    this.getData({});
  },
};
</script>